module.exports = __webpack_public_path__ + "img/transaction_min.43f37940.jpg";